import { memo } from 'react';
import InfoItem from '@/components/common/InfoItem';

interface TextInfoItemProps {
    label: string;
    labelId: string;
    value: string | null | undefined;
}

/**
 * Displays a text-based info item for call details.
 *
 * @param {TextInfoItemProps} props
 * @returns {JSX.Element}
 */
const TextInfoItem: React.FC<TextInfoItemProps> = ({ label, labelId, value }) => (
    <InfoItem label={label} value={value} labelId={labelId} variant="filled" direction="horizontal" status="default" />
);

export default memo(TextInfoItem);
